module.exports = __webpack_public_path__ + "74bb9ea6ff6af60538138ff3825b4b75.svg";